import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllContratoArquivoUseCase } from "../../../presentation/useCases/read/get_all_contrato_arquivo_use_case";
import { IGetAllContratoInformacoesUseCase } from "../../../presentation/useCases/read/get_all_contrato_informacoes_use_case";
import { ContratoArquivoFilter } from "../../models/contrato_arquivo_filter";
import { ContratoArquivoLista } from "../../models/contrato_arquivo_lista";
import { ContratoInformacoesFilter } from "../../models/contrato_informacoes_filter";
import { ContratoInformacoesLista } from "../../models/contrato_informacoes_lista";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


// GetAllContratoInformacoesUseCase


export class GetAllContratoInformacoesUseCase
  extends BasePaginatedUseCase<ContratoInformacoesLista>
  implements IGetAllContratoInformacoesUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {
    super();
  }

  async getAllListagemContratoInformacoes(
    filter: ContratoInformacoesFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemContratoInformacoes(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
